import { useTranslation } from "react-i18next";
import { NeedStatus } from "../../autogen/bff-api";

export const useNeedStatusLabel = () => {
  const { t } = useTranslation();
  return (status: NeedStatus): string => needStatusLabel(status, t);
};

export const needStatusLabel = (status: NeedStatus, t: (key: string) => string): string => {
  switch (status) {
    case NeedStatus.Draft:
      return t("Draft");
    case NeedStatus.Reported:
      return t("Reported");
    case NeedStatus.SentBack:
      return t("Sent back");
    case NeedStatus.Approved:
      return t("With procurement");
    case NeedStatus.Planned:
      return t("Planned");
    case NeedStatus.FrameworkRecommended:
      return t("Framework recommended");
    case NeedStatus.ProcurementCreated:
      return t("Procurement created");
    case NeedStatus.UnderProcurement:
      return t("Under procurement");
    case NeedStatus.UnderCallOff:
      return t("Under call-off");
    case NeedStatus.Completed:
      return t("Completed");
    case NeedStatus.Rejected:
      return t("Rejected");
    case NeedStatus.Withdrawn:
      return t("Withdrawn");
  }
};

export const HELD_BY_PROCUREMENT: NeedStatus[] = [NeedStatus.Approved, NeedStatus.Planned];

/** Status options in the shared list filter. «Mine behov» adds DRAFT, since the server returns only the caller's own drafts. */
export const NEED_STATUS_FILTER_OPTIONS: NeedStatus[] = [
  NeedStatus.Reported,
  NeedStatus.SentBack,
  NeedStatus.Approved,
  NeedStatus.Planned,
  NeedStatus.FrameworkRecommended,
  NeedStatus.ProcurementCreated,
  NeedStatus.UnderProcurement,
  NeedStatus.UnderCallOff,
  NeedStatus.Completed,
  NeedStatus.Rejected,
  NeedStatus.Withdrawn,
];
